/** A learning day starts at 04:00 local time, so late-night practice counts for the day before. */
export const DAY_START_HOUR = 4;

/** The learning day of a moment, as YYYY-MM-DD. */
export function dayKey(at: Date): string {
  const d = new Date(at.getTime());
  if (d.getHours() < DAY_START_HOUR) d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** The moment the learning day containing `at` ends: the next 04:00. */
export function endOfDay(at: Date): Date {
  const d = new Date(at.getTime());
  if (d.getHours() >= DAY_START_HOUR) d.setDate(d.getDate() + 1);
  d.setHours(DAY_START_HOUR, 0, 0, 0);
  return d;
}

/** Whole learning days from `from` to `to` (positive when `to` is later). */
export function daysBetween(from: Date, to: Date): number {
  const a = parseDay(dayKey(from));
  const b = parseDay(dayKey(to));
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}

export function parseDay(key: string): Date {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y, m - 1, d, 12);
}

/** Monday-first days of the week containing the learning day of `at`. */
export function weekDays(at: Date): string[] {
  const today = parseDay(dayKey(at));
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return dayKey(d);
  });
}

/** "today", "tomorrow", "in 3 days", "in 2 weeks", "in a month"… for a future moment. */
export function whenLabel(due: Date, now: Date): string {
  const days = daysBetween(now, due);
  if (days <= 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days < 14) return `in ${days} days`;
  if (days < 30) return `in ${Math.round(days / 7)} weeks`;
  if (days < 45) return 'in a month';
  if (days < 365) return `in ${Math.round(days / 30)} months`;
  return 'in over a year';
}
